import React from 'react';
import PropTypes from 'prop-types';
import {Draggable, Droppable} from "react-beautiful-dnd";
import Column from "./TableColumns/Column";

const grid = 8;

const ColumnsList = props => {
  return (
    <Droppable key={props.id} droppableId={props.id}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          className="d-flex flex-column h-100"
          {...provided.droppableProps}
        >
          {props.columns.map((column, index) => {
            return <Draggable
              key={column.id}
              draggableId={column.id}
              index={index}
            >
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                  className="list-group-item p-0"
                >
                  <Column
                    listId={props.id}
                    content={column.name}
                    width={column.width}
                    isLast={index === props.columns.length-1}
                    onChangeWidth={width => props.onColumnUpdate(index, {
                      ...column,
                      width
                    })}
                  />
                </div>
              )}
            </Draggable>
          })}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

ColumnsList.propTypes = {
  onColumnUpdate: PropTypes.func.isRequired,
};

export default ColumnsList;
